import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';
import './spinner.scss';

export default function SpinnerIcon(props) {
	return (
		<IconBase type="spinner" {...props}>
			<path d="m12.33 2.01c-3.112-0.10052-6.1717 1.2569-8.1758 3.791-2.6722 3.3788-2.8789 8.1021-0.51172 11.701l1.7266-1.1367c-1.8822-2.8616-1.7184-6.5947 0.40625-9.2812 2.1247-2.6866 5.7224-3.7066 8.9414-2.5352l0.70508-1.9414c-1.0121-0.36831-2.0545-0.56415-3.0918-0.59766z" />
		</IconBase>
	);
}
SpinnerIcon.propTypes = iconPropTypes;
